import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { id: "sample" };
import { computed, toRef } from "vue";
import Editor from "@tinymce/tinymce-vue";
import { useBuiltComponentVariables } from "src/shared/store/component-built/composables";
import { useDestructuredEvaluatableValue } from "src/shared/evaluatable";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HtmlComponentVariableRawValue',
    props: {
        modelValue: {},
        componentId: {},
        height: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isString = (value) => {
            return typeof value === "string";
        };
        const valueProxy = computed({
            get() {
                return isString(props.modelValue) ? props.modelValue : "";
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        const { value } = useDestructuredEvaluatableValue(valueProxy);
        const { builtComponentVariables } = useBuiltComponentVariables(toRef(props, "componentId"));
        const componentVariableMergeTags = computed(() => {
            return builtComponentVariables.value
                .map((componentVariable) => {
                return {
                    value: componentVariable.name,
                    title: componentVariable.getDisplayName(),
                };
            })
                .flat();
        });
        const editorConfiguration = computed(() => {
            return {
                plugins: "code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount mergetags autoresize",
                toolbar: "mergetags | code | undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat",
                mergetags_list: componentVariableMergeTags.value,
                skin: 'borderless',
            };
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("main", _hoisted_1, [
                _createVNode(_unref(Editor), {
                    "api-key": "cfzglkk71nbjp3d1190ssvxe6xckw060ob8khtt4kutncah0",
                    init: editorConfiguration.value,
                    "initial-value": "Welcome to TinyMCE!",
                    modelValue: _unref(value),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(value) ? (value).value = $event : null))
                }, null, 8 /* PROPS */, ["init", "modelValue"])
            ]));
        };
    }
});
